module.exports = __webpack_public_path__ + "static/media/vertex_figure_polytope_52_5_3.16b0efd6.png";